import * as React from 'react';

import { ReactComponent as Email } from '../../../../styles/img/email.svg';

import s from './InformationSection.module.scss';

const InformationSection: React.FC = () => {
  return (
    <section className={s.wrapper}>
      <Email className={s.icon} />
      <div className={s.text}>
        Let&rsquo;s achieve financial goals and maximize return
        on&nbsp;investment together! Contact&nbsp;us via our email!
      </div>
    </section>
  );
};

export default InformationSection;
